export default __webpack_public_path__ + "static/media/precios_LEED_feb_sumeV.15ad2b1b.png";